export const VENDOR_LIST = "VENDOR_LIST";
export const VENDOR_ALLOCATE = "VENDOR_ALLOCATE";
export const VENDOR_SERVICE_DETAIL = "VENDOR_SERVICE_DETAIL";
export const POST_VENDOR_SERVICE = "POST_VENDOR_SERVICE";
